import { Link, useLocation } from 'react-router-dom';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 爆料看点',
    description: '你访问的页面不存在或已被移动，可返回首页或前往拆解档案库继续浏览事件拆解内容。',
    path: location.pathname,
  });

  return (
    <section className="paper-grain flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <span className="font-label text-xs tracking-[0.3em] text-primary-600">404 / NOT FOUND</span>
      <p className="mt-6 font-heading text-6xl font-bold text-background-400 md:text-8xl">404</p>
      <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这条线没接上，页面不存在
      </h1>
      <p className="mt-3 font-body text-sm text-foreground-600">
        你访问的地址是
        <span className="mx-1 rounded bg-background-200 px-2 py-0.5 font-mono text-xs text-foreground-800">
          {location.pathname}
        </span>
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/dossiers"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-foreground-800"
        >
          <i className="ri-book-open-line" />
          浏览拆解档案
        </Link>
      </div>
    </section>
  );
}